import React, { useEffect, useState } from 'react'
import PageHeader from '../Shared/PageHeader'
import Card from './Card'
import CardSkeleton from './CardSkeleton'
import { Pagination } from '../../components/ui/pagination'

const shimmer = {
  background: 'linear-gradient(90deg, rgba(255,255,255,0.03) 25%, rgba(255,255,255,0.09) 50%, rgba(255,255,255,0.03) 75%)',
  backgroundSize: '200% 100%',
  animation: 'skeleton-shimmer 1.6s ease-in-out infinite',
  borderRadius: '9px',
}

const PaginationSkeleton = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '6px', marginTop: '40px' }}>
    <div style={{ ...shimmer, width: '72px', height: '36px' }} />
    {[1, 2, 3].map((i) => (
      <div key={i} style={{ ...shimmer, width: '36px', height: '36px' }} />
    ))}
    <div style={{ ...shimmer, width: '60px', height: '36px' }} />
  </div>
)

const Portfolio = () => {
  const [projects, setProjects] = useState([])
  const [count, setCount] = useState(0)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(3)
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    const timer = setTimeout(() => {
      fetch(`https://portfolio-server-ten-theta.vercel.app/project?page=${page}`)
        .then((res) => res.json())
        .then((data) => {
          setProjects(data.projects)
          setCount(data.count)
          if (page === 1 && data.projects.length > 0) setPageSize(data.projects.length)
          setLoading(false)
        })
    }, 200)
    return () => clearTimeout(timer)
  }, [page])

  const totalPages = pageSize > 0 ? Math.ceil(count / pageSize) : 1

  return (
    <div>
      <PageHeader title='Portfolio' />

      {isLoading ? (
        <>
          <CardSkeleton cards={pageSize || 3} />
          <PaginationSkeleton />
        </>
      ) : (
        <>
          <div className='grid pt-10 pb-5 lg:grid-cols-3 gap-5'>
            {projects.map((project, i) => (
              <Card key={project._id} project={project} index={i} />
            ))}
          </div>
          {totalPages > 1 && (
            <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
          )}
        </>
      )}
    </div>
  )
}

export default Portfolio
